import React, {useState, useRef, Fragment, useEffect} from 'react';
import SelectListSection from '../../../../components/FormSections/Fields/SelectListSection';
import {MapSquareSelection, Loader, Credit_price} from '../../../../components';
import Typography from '@material-ui/core/Typography';
import {connect} from 'react-redux';


function Auto_search(props){
    let credits_data_requested=useRef(false);

    let map_data={}; if(props.getMapData.current!=undefined){map_data=props.getMapData.current();}

    let credit_cost=undefined;
    if(props.credits_data!=undefined && props.credits_data!='loading'){
      credit_cost=map_data['max_results']*props.credits_data.credit_menu['COMPANY_GOOGLE_MAPS'].credit_amount;
    }

    if(credits_data_requested.current==false && props.credits_data==undefined){
      props.getCreditsData();
      credits_data_requested.current=true;
    }
    return(
      <Fragment>{
        (props.last_search_message.current==false)?
                        (props.map_processed.current==false)?
                        <div style={{position:'relative', height:'100%', width:'100%'}}>
                          <div style={{position:'relative', height:'100%', width:'100%'}}><MapSquareSelection {...props} data={map_data} returnResults={props.returnResults} credits_data={(props.credits_data=='loading')?null:props.credits_data}/></div>
                        </div>
                        :<div style={{position:'relative', height:'100%', width:'100%'}}>
                          <Typography style={{marginTop:'20px', marginLeft:'20px', width:'calc(100% -40px)', textAlign:'center'}}>Which list would you like the results to be added to?</Typography>
                          <div style={{marginTop:'10px', display:'flex', justifyContent:'center', alignItems:'left'}}><SelectListSection list_error={props.list_error} {...props} automated_error={props.automated_error} setListDone={props.setListDone} no_style_list_id/></div>
                          <hr style={{marginTop:'20px', marginBottom:'20px'}}/>
                          {(props.credits_data==undefined || props.credits_data=='loading')?
                            <div style={{marginTop:'40px'}}><Loader loading embed /></div>
                            :
                            <div style={{marginLeft:'20px'}}>
                              <div><Typography variant='caption'>{" - Maximum results: "}<b>{map_data['max_results']}</b></Typography></div>
                              <div><Typography variant='caption'>{" - Maximum credits required: "}<b>{credit_cost}</b></Typography></div>
                              <div><Typography variant='caption'>{" - Current credits: "}<b>{Number(props.credits_data.account_info.total_credits)}</b></Typography></div>
                              {(credit_cost - Number(props.credits_data.account_info.total_credits) <= 0)?null:
                                <Fragment>
                                  <div><Typography variant='caption' style={{color:'red'}}>{" - Missing credits: "}<b>{credit_cost - Number(props.credits_data.account_info.total_credits)}</b></Typography></div>
                                  <div style={{marginTop:'20px'}}><Typography variant='caption'>Ensure you have enough credits. Proceed to <b>checkout</b> to purchase more credits or go back and adjust the maximum results parameter.</Typography></div>
                                </Fragment>
                              }
                              <div style={{marginTop:'20px'}}><Typography variant='caption'>{"We will deduct "}<Credit_price bold small service_identifier="COMPANY_GOOGLE_MAPS"/> for every result we find</Typography></div>
                            </div>
                          }
                        </div>
                    :<div>
                    {(props.automated_search_completed!=true)?<div style={{marginTop:'30px'}}><Loader embed loading/></div>:<Typography style={{textAlign:'center', width:'calc(100% - 40px)', marginLeft:'20px', marginTop:'40px'}}>Your search is being processed. We will send you a notification once it is completed.</Typography>}
                    </div>
              }</Fragment>
    )
}


export default connect(ss,dd)(Auto_search)



function ss(state){
  return{
    credits_data:state.account.credit_menu
  }
}

function dd(dispatch){
  return{
    getCreditsData:()=>{dispatch({type:'REQUEST_GET_CREDIT_MENU'});}
  }
}
